import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"

interface NagModalProps { 
  title: string;
  message: string;
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
}

const NagModal: React.FC<NagModalProps> = ({
  title,
  message,
  open,
  onOk,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => onCancel()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onOk()} autoFocus>
          Ok
        </Button>
        <Button onClick={() => onCancel()} autoFocus>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default NagModal
